module.exports = __webpack_public_path__ + "img/introduction_icon_four@2x.28e37f7c.png";